import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Address } from 'src/app/shared/models/address';
import { ServiceCenter } from 'src/app/shared/models/service-center';
import {
	CompetenceSSIAD,
	CompetenceSESSAD,
	CompetenceSAAD
} from 'src/app/shared/enums/competence.enum';
import { FacadeService } from 'src/app/core/services/facade.service';
import { LogService } from 'src/app/core/services/log/log.service';
import { Profile } from 'src/app/shared/models/security/profile';
import { CacheService } from 'src/app/core/services/cache/cache.service';
import { PARAM_LABEL_BENEFICIAIRE } from 'src/app/core/services/constant/constants.service';
import { ToastService } from 'src/app/core/services/toast/toast.service';
import { ErrorResponse } from 'src/app/shared/models/api-response/error-response';

@Component({
	selector: 'app-role-modal-ajout-form',
	templateUrl: './role-modal-ajout-form.component.html',
	styleUrls: ['./role-modal-ajout-form.component.scss']
})
export class RoleModalAjoutFormComponent implements OnInit {
	LABEL_BENEFICIAIRE: string;
	serviceCenter: ServiceCenter;
	enumCompetences;

	isAddressSelected: { value: boolean } = { value: false };
	isAddressDefault: { value: boolean } = { value: true };

	isPreferencesActive = false;

	role = new Profile();

	MAX_NAME_CHAR = 25;
	NAME_PATTERN = "^[0-9a-zA-Z,.'éèàçÀÆæÇÉÈŒœÙ-]+( [0-9a-zA-Z,.'éèàçÀÆæÇÉÈŒœÙ-]+)*$";
	form = new FormGroup({
		name: new FormControl('', [
			Validators.required,
		]),
		description: new FormControl(''),
	});

	//Boolean empêchant l'utilisateur d'envoyer plusieurs fois le formulaire
	isValidateButtonClicked: { value: boolean } = { value: false };

	isSESSAD = false;
	isSAAD = false;
	isSSIAD = false;

	@Output() updateListing = new EventEmitter();


	constructor(
		public bsModalRef: BsModalRef,
		private facade: FacadeService,
		private toastService: ToastService
	) {}

	ngOnInit(): void {
		this.LABEL_BENEFICIAIRE =
			this.facade.dataStorageService.getLabelCapitalized(
				PARAM_LABEL_BENEFICIAIRE
			);
		//this.isPreferencesActive =
		//	this.facade.dataStorageService.isPreferencesRoleActive();
		// this.isSESSAD = this.facade.dataStorageService.isSESSAD();
		// this.isSAAD = this.facade.dataStorageService.isSAAD();
		// this.isSSIAD = this.facade.dataStorageService.isSSIAD();
		this.enumCompetences = this.isSESSAD
			? CompetenceSESSAD
			: this.isSAAD
			? CompetenceSAAD
			: CompetenceSSIAD;
	}

	onSubmit() {
		this.isValidateButtonClicked.value = true;
		this.facade.profileService
			.addProfile(this.role)
			.subscribe({
				next: (addedRoleId: number) => {
					this.role.id = addedRoleId;
					this.isValidateButtonClicked.value = false;
					this.bsModalRef.hide();
					this.updateListing.emit(this.role);
				},
				error: (err: ErrorResponse) => {
					this.isValidateButtonClicked.value = false;
					this.toastService.createHttpErrorToast(
						err.error.message,
						err.status
					);
				}
			});
	}
}
